import {
  Avatar,
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RouteUrls } from "../../../Constants/RouteUrls";
import { registrationFormData } from "./Data";
import { FormDataType } from "DataTypes/Form";
import { commonFormSwitch, ControlledBoxSizeSwitch } from "Utils/SwitchCases";
import { HandleFormChange } from "Utils/Common";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ControlledForm from "Components/ControlledForm";
import authApi from "Service/Auth.api";
import ImgPath from "Constants/Imgs";
import { OrgDropArr } from "Constants/Arrays";

const CustomerRegister = () => {
  const navigate = useNavigate();
  const urlPath = window.location.pathname;
  console.log(urlPath, "URLPATH");
  const isCorporate = urlPath.includes(RouteUrls.corporate);
  const [formData, setFormData] = useState<FormDataType[]>([]);
  const [emailData, setEmailData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const [contactData, setContactData] = useState<{
    fieldVal: string;
    otpSend: boolean;
    otpVal: string;
    otpVerified: boolean;
  }>({
    fieldVal: "",
    otpSend: false,
    otpVal: "",
    otpVerified: false,
  });
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const newArr = JSON.parse(JSON.stringify(registrationFormData()));
    if (isCorporate) {
      newArr.push({
        id: "organization",
        label: "Organization",
        boxType: "single-select-drop",
        validatetype: "dropdown",
        boxSize: 3,
        dropArr: OrgDropArr,
        placeholder: "Select Organization",
      });
    }
    setFormData(newArr);
  }, []);

  const handleSendOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {
    if (otpType == "email") {
      const res = await authApi.emailSendOtp({
        email: emailData.fieldVal,
        requestType: "register",
      });
      if (res?.success) {
        setEmailData({
          fieldVal: emailData.fieldVal,
          otpSend: true,
          otpVal: "",
          otpVerified: false,
        });
      }
    } else {
      const res = await authApi.mobileSendOtp({
        mobileNumber: contactData.fieldVal,
        requestType: "register",
      });
      if (res?.success) {
        setContactData({
          fieldVal: contactData.fieldVal,
          otpSend: true,
          otpVal: "",
          otpVerified: false,
        });
      }
    }
  };
  const handleVerifyOtp: (otpType: "email" | "contact") => void = async (
    otpType
  ) => {
    if (otpType === "email") {
      const res = await authApi.verifyOtp({
        mobileNumber: null,
        email: emailData.fieldVal,
        otp: emailData.otpVal,
      });
      if (res?.success) {
        setEmailData({
          fieldVal: emailData.fieldVal,
          otpSend: true,
          otpVal: emailData.otpVal,
          otpVerified: true,
        });
      }
    } else {
      const res = await authApi.verifyOtp({
        mobileNumber: contactData.fieldVal,
        email: null,
        otp: contactData.otpVal,
      });
      if (res?.success) {
        setContactData({
          fieldVal: contactData.fieldVal,
          otpSend: true,
          otpVal: contactData.otpVal,
          otpVerified: true,
        });
      }
    }
  };

  const handleRegister = async () => {
    const payload = {
      firstName: formData[0].value,
      lastName: formData[1].value,
      address: formData[2].value,
      city: formData[3].value,
      state: formData[4].value,
      postalCode: formData[5].value,
      dateOfBirth: formData[6].value,
      // description: formData[7].value,
      password: formData[7].value,
      highestQualification: "",
      profilePicturePath: "",
      email: emailData.fieldVal,
      contactNumber: contactData.fieldVal,
      // userType: "User",
    };

    const res = await authApi.registerUser(payload);
    if (res?.success) {
      navigate(`/${RouteUrls.login}`);
    }
  };
  const handleCorporateRegister = async () => {
    const payload = {
      firstName: formData[0].value,
      lastName: formData[1].value,
      address: formData[2].value,
      city: formData[3].value,
      state: formData[4].dropValue,
      postalCode: formData[5].value,
      dateOfBirth: formData[6].value,
      password: formData[7].value,
      corporateOrg: formData[8].dropValue,
      highestQualification: "",
      profilePicturePath: "",
      email: emailData.fieldVal,
      contactNumber: contactData.fieldVal,
      // userType: "User",
    };

    const res = await authApi.registerCorporateUser(payload);
    if (res?.success) {
      navigate(`/${RouteUrls.PendingVerification}`);
    }
  };

  const handlePasswordToggle = (fieldId: string) => {
    setFormData((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? { ...field, showPassword: !field.showPassword }
          : field
      )
    );
  };

  return (
    <Box sx={{ height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box
          component="img"
          src={"https://nolegalpaisa.com/assets/images/nlp_logo.png"}
          alt="Logo"
          sx={{
            width: { xs: "150px", sm: "200px", md: "230px" },
            height: { xs: "60px", sm: "80px", md: "83px" },
            objectFit: "contain",
            cursor: "pointer",
            filter: "drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.3))",
            transition: "transform 0.2s ease-in-out",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
          onClick={() => (window.location.href = "/home.html")}
        />
        <Typography
          component="h1"
          variant="h4"
          sx={{
            flex: 1,
            textAlign: "center",
            color: "primary.main",
            fontWeight: 600,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          {isCorporate ? "Sign Up as Corporate" : "Sign Up"}
        </Typography>
        <Box sx={{ width: "180px" }} /> {/* Spacer to balance the layout */}
      </Box>
      <Grid
        container
        component="main"
        sx={{ flex: 1 }}
        alignItems="center"
        justifyContent="center"
      >
        {!isSmallScreen && (
          <Grid
            sx={{
              backgroundImage: 'url("/images/signup-bg.jpg")',
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100%",
            }}
          />
        )}
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            py: 4,
          }}
        >
          <Box
            sx={{
              mx: 4,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box component="form" noValidate sx={{ mt: 1, width: "100%" }}>
              <Grid mb={2} container columnSpacing={2} rowSpacing={2}>
                {formData.length > 0 &&
                  formData.map((el: FormDataType) => (
                    <Grid
                      key={el.id}
                      size={{ ...ControlledBoxSizeSwitch(el.boxSize) }}
                    >
                      {commonFormSwitch({
                        formObj: {
                          ...el,
                          onPasswordToggle: el.hasPasswordToggle
                            ? () => handlePasswordToggle(el.id)
                            : undefined,
                        },
                        onChange: (data) =>
                          setFormData(HandleFormChange(data, formData)),
                      })}
                    </Grid>
                  ))}
              </Grid>

              <Grid container columnSpacing={2} rowSpacing={2}>
                <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <ControlledForm.Input
                    id="email"
                    value={emailData.fieldVal}
                    label="Email"
                    {...(emailData.otpVerified && {
                      focused: true,
                      borderColor: "success",
                      readOnly: true,
                    })}
                    onChange={(value) =>
                      setEmailData({ ...emailData, fieldVal: value as string })
                    }
                  />
                </Grid>
                <Grid
                  key={"email"}
                  sx={{ display: emailData.otpSend == true ? "block" : "none" }}
                  size={{ ...ControlledBoxSizeSwitch(3) }}
                >
                  <ControlledForm.Input
                    id="emailOtp"
                    label="Email OTP"
                    {...(emailData.otpVerified && {
                      iconId: "check-icon",
                      infoText: "Email Verified",
                      readOnly: true,
                    })}
                    value={emailData.otpVal}
                    onChange={(value) =>
                      setEmailData({ ...emailData, otpVal: value as string })
                    }
                  />
                </Grid>
                <Grid key={"email"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <Button
                    // fullWidth
                    variant="contained"
                    sx={{ mt: 3 }}
                    onClick={() =>
                      emailData.otpSend
                        ? handleVerifyOtp("email")
                        : handleSendOtp("email")
                    }
                    disabled={emailData.otpVerified}
                  >
                    {emailData.otpSend === true ? "Verify" : "Send OTP"}
                  </Button>
                  <IconButton
                    sx={{ mt: 3 }}
                    title="Reset"
                    onClick={() =>
                      setEmailData(
                        JSON.parse(
                          JSON.stringify({
                            fieldVal: "",
                            otpSend: false,
                            otpVal: "",
                            otpVerified: false,
                          })
                        )
                      )
                    }
                  >
                    <ImgPath.RestoreIcon />
                  </IconButton>
                </Grid>
              </Grid>

              <Grid mt={2} container columnSpacing={2} rowSpacing={2}>
                <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <ControlledForm.Input
                    id="contact"
                    value={contactData.fieldVal}
                    {...(contactData.otpVerified && {
                      focused: true,
                      borderColor: "success",
                      readOnly: true,
                    })}
                    label="Contact"
                    onChange={(value) =>
                      setContactData({
                        ...contactData,
                        fieldVal: value as string,
                      })
                    }
                  />
                </Grid>
                <Grid
                  key={"contactOtp"}
                  sx={{
                    display: contactData.otpSend === true ? "block" : "none",
                  }}
                  size={{ ...ControlledBoxSizeSwitch(3) }}
                >
                  <ControlledForm.Input
                    id="contactOtp"
                    value={contactData.otpVal}
                    label="Contact OTP"
                    readOnly={contactData.otpVerified}
                    {...(contactData.otpVerified && {
                      iconId: "check-icon",
                      infoText: "Contact Number Verified",
                    })}
                    onChange={(value) =>
                      setContactData({
                        ...contactData,
                        otpVal: value as string,
                      })
                    }
                  />
                </Grid>
                <Grid key={"contact"} size={{ ...ControlledBoxSizeSwitch(3) }}>
                  <Button
                    // fullWidth
                    variant="contained"
                    sx={{ mt: 3 }}
                    onClick={() =>
                      contactData.otpSend
                        ? handleVerifyOtp("contact")
                        : handleSendOtp("contact")
                    }
                    disabled={contactData.otpVerified}
                  >
                    {contactData.otpSend === true ? "Verify" : "Send OTP"}
                  </Button>
                  <IconButton
                    sx={{ mt: 3 }}
                    title="Reset"
                    onClick={() =>
                      setContactData(
                        JSON.parse(
                          JSON.stringify({
                            fieldVal: "",
                            otpSend: false,
                            otpVal: "",
                            otpVerified: false,
                          })
                        )
                      )
                    }
                  >
                    <ImgPath.RestoreIcon />
                  </IconButton>
                </Grid>
              </Grid>

              <Button
                variant="contained"
                sx={{ mt: 3 }}
                onClick={isCorporate ? handleCorporateRegister : handleRegister}
                disabled={!emailData.otpVerified && !contactData.otpVerified}
              >
                Sign Up
              </Button>

              <Typography
                sx={{
                  textAlign: "center",
                  textDecoration: "underline",
                  cursor: "pointer",
                  mt: 2,
                }}
                variant="body2"
                onClick={() => navigate(`/${RouteUrls.login}`)}
              >
                Already have an account? Login
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CustomerRegister;
